<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight" size="small"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getOperatorInfoUrl" @listData='getDeviceData'></MyPage>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
	</div>


</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './Template/Form.vue';
	import infoModal from './Template/Modal.vue';
	import webapi from '../../../webapi.js';
	export default {
		components: {
			searchForm,
			infoModal
		},
		data() {

			return {
				getOperatorInfoUrl: webapi.base_api_url + '/Archives/GetOperatorInfo',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,tableHeight: "650",
				BreadcrumbList: [this.$tt('会员中心'), '>>', this.$tt('会员交易')],




				//table标题数据
				columns1: [
					//单选示例
					{
						
								title: this.$tt('选择'),
								key: 'id',
								width: 70,
								align: 'center',
								render: (h, params) => {
									let id = params.row.Id;
									let flag = false;
									if (this.selectedFileId === id) {
										flag = true
									}
									let self = this
									return h('div', [
										h('Radio', {
											props: {
												value: this.selectedFileId === id,
												
											},
											on: {
												'on-change': () => {
													self.selectedFileId = id;
												}
											}
										})
									])
								}
							
					},
					//扩展示例
					{
							type: 'expand',
							width: 30,
							render: (h, params) => {
								const _this = this
								return h(expandRow, {
									props: {
										row: [params.row]
									},
									on: {
										// 子组件$emit传递函数
										upCard(GroupId, CardNo) {
											console.log(GroupId + "----" + CardNo)
											_this.openAddChargeCar("up", GroupId, CardNo);
										},
										upData(GroupId, CardNo) {
											_this.handleSubmit();
										},
					
					
									}
								})
							}
						},
					//Table普通实例
					{
						title: this.$tt('ICP备案信息'),
						key: 'IcpNo',
						width: 200
					},
					//Table列表实例
					{
						title: this.$tt('场站列表'),
						key: 'StationArray',
						width: 300,
						
							title: this.$tt('场站列表'),
							key: 'StationArray',
							width: 120,
							render: (h, params) => {
								let arr=[]
									params.row.StationArray.map(item => {
										this.StationList.map(item2 => {
											if(item2.StationId==item){
												arr.push(item2)
											}
										})
									})
									return h('Poptip', {
										props: {
											trigger: 'hover',
											title: params.row.StationArray,
											placement: 'bottom'
										}
									}, [
										h('Tag', this.$tt('查看')),
										h('div', {
											slot: 'content'
										}, [
											h('ul', arr.map(item => {
												
												return h('li', {
													style: {
														textAlign: 'center',
														padding: '4px'
													}
												}, item.StationName)
												
											}))
							
										])
									]);
								
							}
						
						
					}, {
						title: this.$tt('操作'),
						key: 'action',

						align: 'center',
						render: (h, params) => {
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('up',params.row)
										}
									}
								}, this.$tt('修改')),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		//为了不误操作，确定取消相反
								// 		click: () => {
								// 			this.getUpdateMessage(params.row.OperatorId)
								// 		}
								// 		// this.show("deleteStation", params.row.Id)

								// 	}
								// }, this.$tt('查看')),

								h('Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {

												this.$Modal.confirm({
													title: name,
													okText: this.$tt('取消'),
													cancelText: this.$tt('确定'),
													onCancel: () => {

														this.otherMethod(name, params.row.OperatorId);

													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',

											},
											style: {
												marginRight: '5px'
											},
										}, this.$tt('其他操作')),
										h('DropdownMenu', {

											slot: 'list'


										}, [
											this.methodList.map((item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])


									],

								)



							]);
						}
					}
				],
				
				data: [],
				methodList: [{
					Id:0,
					Status: this.$tt('正常')
				}, {
					Id:9,
					Status: this.$tt('锁定')
				}, ]

			
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)

		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {

			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})



		},
		computed: {
			
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {

			

			//删除修改之外的其他操作
			otherMethod: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).Id
				
				this.$axios.post(webapi.base_api_url + "/System/SetUserStatus", {
					Id: Id,
					Status: typeNum
			
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(name + this.$tt('成功'));
						this.handleSubmit();
					}
				})
			
			},

/******************组件固定方法*************************/
			show: function(type, params) {
				this.$refs.ItemModal.show(type, params)
			},
			
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List

			},
			handleSubmit: function() {
				this.$refs.sonPage.getList();

			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},

		},

	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */


	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}



	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
